export const dailySecurityReportLocation = "/reports/sec/dailyreports"